import { FunnelId } from 'constants/funnel';
import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import Link from 'components/ui/Link';
import config from 'config';
import { formatCurrency } from 'utils/currency';
import { useTranslation } from 'hooks/useTranslation';
import ExternalFunnelButton from 'components/Shared/ExternalFunnel/ExternalFunnelButton';

type Props = {
  packagePrice: number;
  className?: string;
};

const ServiceFee = ({ packagePrice, className }: Props): JSX.Element => {
  const { locale, t } = useTranslation();
  const { serviceFee } = config.defaults;

  return (
    <div className={clsx('text-charcoal', className)}>
      <div className="flex">
        <div
          className="rounded-full flex items-center justify-center h-12 w-12 mr-2 md:mr-4 shrink-0"
          style={{ backgroundColor: 'rgba(21, 82, 99, 0.1)' }}
        >
          <Icon className="w-8 h-8" type="ServiceFeePriceTag" color="#155263" />
        </div>
        <div className="leading-8 md:leading-6">
          <p className="font-bold text-navy">
            {t('serviceFee.thisIsYourBestPrice')}
          </p>
          <p>
            {t('serviceFee.foundTheSamePackageForLess')}
            <br />
            <ExternalFunnelButton
              funnelId={FunnelId.CONTACT_FORM}
              renderButton={(openFunnel) => {
                return (
                  <span
                    className="cursor-pointer underline"
                    onClick={openFunnel}
                  >
                    {t('letUsKnow')}
                  </span>
                );
              }}
            />{' '}
            {t('andWeWillMatchIt')}.
          </p>
        </div>
      </div>
      <hr className="md:hidden my-3 mt-6" />
      <table className="text-lg md:text-base mb-6 md:mb-2 leading-2-9r md:leading-10 w-full md:mt-6">
        <tbody>
          <tr>
            <td className="font-bold text-lg mt-6">{t('payment')}</td>
          </tr>
          <tr>
            <td>{t('serviceFee.dueAtBooking')}</td>
            <td className="text-right">
              {formatCurrency(serviceFee, 'EUR', locale)}
            </td>
          </tr>
          <tr>
            <td>{t('serviceFee.paymentAtClinic')}</td>
            <td className="text-right">
              {formatCurrency(packagePrice - serviceFee, 'EUR', locale)}
            </td>
          </tr>
          <tr className="font-bold">
            <td>{t('total')}</td>
            <td className="text-right">
              {formatCurrency(packagePrice, 'EUR', locale)}
            </td>
          </tr>
        </tbody>
      </table>
      <hr className="md:hidden mb-4 -mt-2" />
      <p className="text-md md:text-xs text-qunoGrey">
        {t('serviceFee.learnMoreAboutPaymentsInOur')}{' '}
        <Link href={`/${locale}/${t('footer.terms.link')}`}>
          <a title={t('footer.terms')}>{t('footer.termsShort')}</a>
        </Link>
        .
      </p>
    </div>
  );
};

export default ServiceFee;
